import { render } from "./DocumentsCreateModal.vue?vue&type=template&id=e23bb912"
import script from "./DocumentsCreateModal.vue?vue&type=script&lang=js"
export * from "./DocumentsCreateModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__